var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85082 0.112267C8.03428 0.275342 8.05081 0.556262 7.88773 0.739721L3.147 6.07305C3.06266 6.16793 2.94177 6.22222 2.81482 6.22222C2.68787 6.22222 2.56698 6.16793 2.48263 6.07305L0.112267 3.40638C-0.0508073 3.22293 -0.0342826 2.942 0.149176 2.77893C0.332635 2.61586 0.613556 2.63238 0.77663 2.81584L2.81482 5.1088L7.22337 0.149176C7.38644 -0.0342826 7.66736 -0.0508073 7.85082 0.112267Z",
    fill: "#377A83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e93d746d2574c12ddbc73c3e0fac1299.svg";
export { ForwardRef as ReactComponent };